module.exports = __webpack_public_path__ + "media/images/checkout-header-background-fc48ce0113b9ade825437dd8d0b8c7b2.png";